export class ResetPasswordFields {
  token: string;
  password: string;
  password2: string;
  new_password?: string;
}
